import { render } from "./FormsChoosePage.vue?vue&type=template&id=4ba8d59e"
import script from "./FormsChoosePage.vue?vue&type=script&lang=js"
export * from "./FormsChoosePage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__